// Titles list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="title"
      title="Titles"
      api="admin/prefilled-field-option"
      url="title"
      columnsKey="title"
      quickKey="optionName"
      quickPlaceholder="Filter by name…"
      localityFilter
      perms={["tlr", "tlc", "tlu", "tld"]}
    />
  );
}
